import { getAuthRequest } from '../../Api/api';
import { PLACEHOLDER_IMG_SRC } from '../../constant/constants';

/**
 * This functions is to get preview url for logo from backend
 *
 * @param {string} storeLogoURL
 * @returns url that can be used to display image
 */
export const getStoreLogoPreviewUrl = async (storeId) => {
  if (!storeId) return PLACEHOLDER_IMG_SRC;
  try {
    const previewUrl = await getAuthRequest('/generate-view-url?storeId=' + storeId);
    if (previewUrl?.resStatus == 0) throw new Error('Logo not found');
    return previewUrl;
  } catch (err) {
    console.log(err);
    return PLACEHOLDER_IMG_SRC;
  }
};
